import EmptyState from "@/app/components/elements/EmptyState";
import { PackageX } from "lucide-react";

const ProductsEmptyState = () => {
  return (
    <EmptyState
      icon={PackageX}
      title="Ürün Bulunamadı"
      description="Bu bölümde henüz ürün bulunmamaktadır. Lütfen daha sonra tekrar kontrol edin."
      actions={[
        {
          label: "Alışverişe Devam Et",
          href: "/",
          variant: "default",
        },
      ]}
    />
  );
};

export default ProductsEmptyState;